// extracted by mini-css-extract-plugin
export var contentcard = "single-product-module--contentcard--gLcW0";